import ImageBlockElement from '@/domain/scene/generic/ImageBlockElement.js'
import {
  lengthContraction,
  travelTime as relativisticTravelTime,
  timeDilation,
  remoteClockTime
} from '@/domain/physics/SpecialRelativity.js'
import { travelTime as classicalTravelTime } from '@/domain/physics/ClassicalMechanics.js'

export default class Light extends ImageBlockElement {
  constructor (name, widthRel, heightRel, initXRel, initYRel, color, imageSrc, imageWidth, imageHeight, clockPos) {
    super(name, widthRel, heightRel, initXRel, initYRel, color, imageSrc, imageWidth, imageHeight)
    this.clockPos = clockPos
    this.isLightOn = false
  }

  setOnScene (sceneWidth, sceneHeight, speedC = null) {
    super.setOnScene(sceneWidth, sceneHeight, speedC)

    if (speedC !== null) {
      this.x = (sceneWidth * lengthContraction(this.initXRel, speedC)) - (this.width / 2)
    }
  }

  setValue (lightsEnabled, isObserverInTrain, oppositeObjPos, isRelativistic, speedValue) {
    let isClockInTrain = (this.clockParent === 'train')
    let timeValue

    if (isRelativistic) {
      if ((isObserverInTrain && !isClockInTrain) || (!isObserverInTrain && isClockInTrain)) {
        let tt = relativisticTravelTime((isClockInTrain ? 1 : -1) * oppositeObjPos, speedValue)
        let dilatedTime = timeDilation(tt, speedValue)
        let rct = remoteClockTime(this.clockPos, dilatedTime, speedValue)
        timeValue = rct
      } else {
        timeValue = relativisticTravelTime((isClockInTrain ? -1 : 1) * oppositeObjPos, speedValue)
      }
    } else {
      if ((isObserverInTrain && !isClockInTrain) || (!isObserverInTrain && isClockInTrain)) {
        timeValue = classicalTravelTime((isClockInTrain ? 1 : -1) * oppositeObjPos, speedValue)
      } else {
        timeValue = classicalTravelTime((isClockInTrain ? -1 : 1) * oppositeObjPos, speedValue)
      }
    }

    this.isLightOn = (lightsEnabled && (timeValue >= 0.0))
  }
}
